// extracted by mini-css-extract-plugin
export default {"table":"RegistrTable_table__9Lzbk","head":"RegistrTable_head__Z2wnj","inner":"RegistrTable_inner__3deER","dates":"RegistrTable_dates__e0yRr"};